export function createDotNavigationPlugin(wrapper) {
  return (slider) => {
    let dots

    function markup(remove) {
      remove ? wrapper.destroy() : wrapper.create(slider)
      dotMarkup(remove)
    }

    function removeElement(element) {
      element.parentNode.removeChild(element)
    }

    function createDiv(className) {
      let div = document.createElement("div")
      let classNames = className.split(" ")
      classNames.forEach((name) => div.classList.add(name))
      return div
    }

    function dotMarkup(remove) {
      if (remove) {
        wrapper.remove(dots)
        return
      }
      dots = createDiv("dots")
      slider.track.details.slides.forEach((_e, idx) => {
        let dot = createDiv("dot")
        dot.addEventListener("click", () => slider.moveToIdx(idx))
        dots.appendChild(dot)
      })
      wrapper.add(dots)
    }

    function updateClasses() {
      const slide = slider.track.details.rel

      if (dots) {
        Array.from(dots.children).forEach(function (dot, idx) {
          idx === slide
            ? dot.classList.add("dot--active")
            : dot.classList.remove("dot--active")
        })
      }
    }

    slider.on("created", () => {
      markup()
      updateClasses()
    })
    slider.on("optionsChanged", () => {
      markup(true)
      markup()
      updateClasses()
    })
    slider.on("slideChanged", () => {
      updateClasses()
    })
    slider.on("destroyed", () => {
      markup(true)
    })
  }
}
